import { ScrollViewScaleContain } from "./ScrollViewScaleContain.js";
import { ScrollViewScaleCover } from "./ScrollViewScaleCover.js";
import { ScrollViewScaleCoverWidth } from "./ScrollViewScaleCoverWidth.js";
import { ScrollViewScaleLetterbox } from "./ScrollViewScaleLetterbox.js";
import { ScrollViewScaleNone } from "./ScrollViewScaleNone.js";
import { ScrollViewScaleOriginal } from "./ScrollViewScaleOriginal.js";
import { ScrollViewScalePillarbox } from "./ScrollViewScalePillarbox.js";

export class ScrollViewScale {
    public static Contain = new ScrollViewScaleContain();
    public static ContainMaxOriginal = new ScrollViewScaleContain(1);
    public static Cover = new ScrollViewScaleCover();
    public static CoverWidth = new ScrollViewScaleCoverWidth();
    public static Letterbox = new ScrollViewScaleLetterbox();
    public static Pillarbox = new ScrollViewScalePillarbox();
    public static None = new ScrollViewScaleNone();
    public static Original = new ScrollViewScaleOriginal();
}